import { render, staticRenderFns } from "./DashboardBanners.vue?vue&type=template&id=20e1d67f&scoped=true&"
import script from "./DashboardBanners.vue?vue&type=script&lang=js&"
export * from "./DashboardBanners.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBanners.vue?vue&type=style&index=0&id=20e1d67f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e1d67f",
  null
  
)

export default component.exports